import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { track } from "@/lib/analytics";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your payment…");

  useEffect(() => {
    const reference = params.get("reference") || params.get("trxref");
    if (!reference) {
      navigate("/", { replace: true });
      return;
    }
    api
      .get(`/payments/verify/${reference}`)
      .then(({ data }) => {
        if (data.status === "success") {
          track("payment_success", { order_number: data.order?.order_number, amount: data.order?.amount });
          navigate("/confirmation", { replace: true, state: { order: data.order } });
        } else {
          setMessage("Payment was not successful.");
          setTimeout(() => navigate("/confirmation", { replace: true, state: { failed: true, message: data.message } }), 1200);
        }
      })
      .catch(() => {
        setMessage("We could not verify your payment.");
        setTimeout(() => navigate("/confirmation", { replace: true, state: { failed: true } }), 1200);
      });
  }, [params, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-5">
      <div className="text-center">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-primary" />
        <p className="mt-4 font-heading text-lg font-semibold text-foreground" data-testid="verify-message">{message}</p>
        <p className="mt-1 text-sm text-muted-foreground">Please do not close this window.</p>
      </div>
    </div>
  );
}
